import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import accounting from 'accounting';
import { TransitionGroup } from 'react-transition-group';

import Overlay from '../Widget/Overlay';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayPublisher from '../Widget/OverlayPublisher';
import WidgetHeader from '../Widget/WidgetHeader';

import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer
} from '../DefaultStyles/Shared';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { isLongText } from '../../components/Shared/commonFunctions';
import CssTransition from '../../components/Transition/CssTransition';
import {
    DonationAmountsContainer,
    Container,
    CloseButtonWrapper,
    CloseButton,
    AbsoluteContainer,
    DonationWrapper
} from '../../components/Donation/DonationStartComponents';
import CustomDonation from '../../components/Donation/CustomDonation';
import DonationAmount from '../../components/Donation/DonationAmount';
import ShareDrawer from '../../components/ShareDrawer';
import Title from '../../components/Donation/Title';

import { donateMore, onCustomAmountChanged, selectAmount } from './actions';
import {
    setOverlayPartnerVisible,
    onBackWithinCard,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import { ThemeConsumer } from '../../utils/theming';
import { isPortrait } from '../../utils/size';
import { CardTypes } from '../../utils/enums';
import { cacheFormData } from '../../utils/formCaching/actions';
import { donationDefaultAmounts } from '../../utils/processWidgetData';
import makeMyDonation from '../../assets/images/make-my-donation.png';

import getIsLegacyDonation from '../../utils/donation/isLegacyDonation';

class DonationStart extends React.Component {
    static propTypes = {
        actionIdentifier: PropTypes.string.isRequired,
        activeAction: PropTypes.object.isRequired,
        awaitingBraintreeResponse: PropTypes.bool.isRequired,
        amounts: PropTypes.arrayOf(PropTypes.number).isRequired,
        apiRequestData: PropTypes.object.isRequired,
        cacheFormData: PropTypes.func.isRequired,
        card: PropTypes.object.isRequired,
        customAmount: PropTypes.string,
        defaultDonationAmount: PropTypes.number,
        description: PropTypes.string.isRequired,
        donateMore: PropTypes.func.isRequired,
        isCustomDonation: PropTypes.bool.isRequired,
        isMobileResolution: PropTypes.bool,
        isMultiActionsCard: PropTypes.bool.isRequired,
        isMultiDonation: PropTypes.bool.isRequired,
        onBackWithinCard: PropTypes.func.isRequired,
        paymentMethod: PropTypes.string.isRequired,
        selectAmount: PropTypes.func.isRequired,
        setExitingCardProps: PropTypes.func.isRequired,
        setOverlayPartnerVisible: PropTypes.func.isRequired,
        shortActionName: PropTypes.string.isRequired
    };

    componentDidMount() {
        this.loadExternalPaymentScripts();
    }

    loadExternalPaymentScripts() {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://pay.google.com/gp/p/js/pay.js';
        document.body.appendChild(script);
    }

    render() {
        const legacyDescriptionStyle = this.props.isLegacyDonation ?
            {fontSize: '20px', lineHeight: '28px'} : {};

        return (
            <ThemeConsumer>
                {theme => (
                    <Container isCustomDonation={this.props.isCustomDonation}>
                        <Overlay />
                        <OverlayPublisher />
                        <OverlayPartner transitionType="right-to-left" />
                        <Body
                            className="body-msn-override"
                            isCustomDonation={this.props.isCustomDonation}
                        >
                            {this.props.isMultiActionsCard && (
                                <CloseButtonWrapper>
                                    <CloseButton
                                        onClick={() => {
                                            this.props.setExitingCardProps(
                                                'donation',
                                                this.props,
                                                this.props.activeAction
                                            );

                                            this.props.onBackWithinCard(
                                                this.props.actionIdentifier,
                                                this.props.card,
                                                true,
                                                true
                                            );
                                        }}
                                    >
                                        +
                                    </CloseButton>
                                </CloseButtonWrapper>
                            )}
                            <WidgetHeader />
                            <Content>
                                <Title
                                    style={this.props.isLegacyDonation ?
                                        {fontSize: '34px'} : {}}
                                    shortActionName={this.props.shortActionName}
                                    onPartnerClick={this.props.setOverlayPartnerVisible}
                                    isLocalRepLoading={false}
                                    isLongText={isLongText(
                                        this.props.shortActionName,
                                        60
                                    )}
                                    isExtraLongText={isLongText(
                                        this.props.shortActionName,
                                        95
                                    )}
                                />
                                <DetailsContainer>
                                    <Details hasPhoto={false}>
                                        {this.props.isMobileResolution ? (
                                            <TransitionGroup>
                                                <CssTransition>
                                                    <Description
                                                        style={legacyDescriptionStyle}
                                                        isLocalRepLoading={false}
                                                        isLongText={isLongText(
                                                            this.props.description,
                                                            90
                                                        )}
                                                        isExtraLongText={isLongText(
                                                            this.props.description,
                                                            160
                                                        )}
                                                        onClick={e =>
                                                            this.props.setOverlayPartnerVisible(
                                                                true,
                                                                e,
                                                                false
                                                            )
                                                        }
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.props.description
                                                        }}
                                                    />
                                                </CssTransition>
                                            </TransitionGroup>
                                        ) : (
                                            <Description
                                                style={legacyDescriptionStyle}
                                                className="ie-donation-description"
                                                isLocalRepLoading={false}
                                                isLongText={isLongText(
                                                    this.props.description,
                                                    90
                                                )}
                                                isExtraLongText={isLongText(
                                                    this.props.description,
                                                    160
                                                )}
                                                onClick={e =>
                                                    this.props.setOverlayPartnerVisible(
                                                        true,
                                                        e,
                                                        false
                                                    )
                                                }
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.description
                                                }}
                                            />
                                        )}
                                    </Details>
                                </DetailsContainer>
                            </Content>
                            <DonationWrapper isPortrait={isPortrait()}>
                                <TransitionGroup
                                    style={{ width: '100%', height: '100%' }}
                                >
                                    {!this.props.isCustomDonation && (
                                        <CssTransition
                                            key={this.props.isCustomDonation ? 1 : 0}
                                        >
                                            {this.props.awaitingBraintreeResponse ? (
                                                <DonationAmountsContainer id="DonationWrapper">
                                                    <LoadingSpinner
                                                        position={'center'}
                                                        width={80}
                                                        height={80}
                                                        stroke={6}
                                                        color={theme.colors.primary}
                                                    />
                                                </DonationAmountsContainer>
                                            ) : (
                                                <DonationAmountsContainer id="DonationWrapper">
                                                    {this.props.amounts
                                                        .map(amount => (
                                                            <DonationAmount
                                                                key={amount}
                                                                amount={amount}
                                                                isMostPopular={
                                                                    this.props
                                                                        .defaultDonationAmount ===
                                                                    amount
                                                                }
                                                                onSelectAmount={() =>
                                                                    this.props.selectAmount(
                                                                        this.props
                                                                            .apiRequestData,
                                                                        {
                                                                            paymentMethod: this
                                                                                .props
                                                                                .paymentMethod,
                                                                            amount: amount
                                                                        }
                                                                    )
                                                                }
                                                            />
                                                        ))
                                                        .concat(
                                                            <DonationAmount
                                                                key="Custom"
                                                                amount={0}
                                                                isMostPopular={false}
                                                                onSelectAmount={() =>
                                                                    this.props.donateMore(
                                                                        true
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                </DonationAmountsContainer>
                                            )}
                                        </CssTransition>
                                    )}
                                </TransitionGroup>
                            </DonationWrapper>
                            <Footer>
                                <ShareDrawer
                                    dontGoToPrevAction={this.props.isMultiDonation}
                                    canGoBack={this.props.isMultiDonation}
                                    beforeBack={() => {
                                        this.props.setExitingCardProps(
                                            'donation',
                                            this.props,
                                            this.props.activeAction
                                        );
                                        if (this.props.isMultiDonation) {
                                            this.props.onBackWithinCard(
                                                this.props.actionIdentifier,
                                                this.props.card,
                                                true
                                            );
                                        }
                                    }}
                                    goBack={() => {
                                        return this.props.card.type ===
                                            CardTypes.actionChoice
                                            ? this.props.onBackWithinCard(
                                                  this.props.actionIdentifier,
                                                  this.props.card,
                                                  true
                                              )
                                            : null;
                                    }}
                                    fullwidth={
                                        this.props.card.type === CardTypes.actionChoice
                                    }
                                    rightAlign={
                                        this.props.card.type !== CardTypes.actionChoice
                                    }
                                    hasBackButton={
                                        this.props.card.type === CardTypes.actionChoice
                                    }
                                    backgroundColor={'#fff'}
                                />
                            </Footer>
                        </Body>
                        <TransitionGroup component={AbsoluteContainer}>
                            {this.props.isCustomDonation && (
                                <CssTransition
                                    key={this.props.isCustomDonation ? 1 : 0}
                                    timeoutInMs={
                                        this.props.isMobileResolution ? 500 : 300
                                    }
                                >
                                    <CustomDonation
                                        paymentMethod={this.props.paymentMethod}
                                        onCancelDonateMore={() =>
                                            this.props.donateMore(false)
                                        }
                                        customAmount={this.props.customAmount}
                                        handleClick={() => {
                                            const values = {
                                                amount: this.props
                                                    .customDonationFormAmount
                                            };
                                            this.props.cacheFormData(values);
                                            this.props.setExitingCardProps(
                                                'donation',
                                                this.props,
                                                this.props.activeAction
                                            );
                                            this.props.selectAmount(
                                                this.props.apiRequestData,
                                                {
                                                    paymentMethod: this.props
                                                        .paymentMethod,
                                                    amount: accounting.unformat(
                                                        values.amount
                                                    )
                                                }
                                            );
                                        }}
                                    />
                                </CssTransition>
                            )}
                        </TransitionGroup>
                    </Container>
                )}
            </ThemeConsumer>
        );
    }
}

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'donation',
            ['/donation', '/donation/start'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const isLegacyDonation = getIsLegacyDonation(state);

        let description = state.widget.activeAction.description;

        if (isLegacyDonation) {
            //adjust the margin and sizing of the logo to match the surrounding text as closely as possible
            const imgHeight = 35
            const img = `
            &nbsp;<div style="display: inline-flex;">
                via&nbsp;
                <img
                    style="height: ${imgHeight}px; margin: 1px 0 0 3px;"
                    src="${makeMyDonation}"
                    alt="Make My Donation"
                />
            </div>`;
            description = description + img;
        }

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            activeAction: state.widget.activeAction,
            amounts: state.widget.activeAction.oneCardCustomAmounts?.length
                ? state.widget.activeAction.oneCardCustomAmounts
                : state.widget.activeAction.amounts?.length
                    ? state.widget.activeAction.amounts
                    : donationDefaultAmounts,
            apiRequestData: state.widget.apiRequestData,
            awaitingBraintreeResponse: state.donation.awaitingBraintreeResponse,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            customAmount: state.donation.customAmount,
            customDonationFormAmount: state.form?.customDonationForm?.values?.amount?.split?.(
                ' '
            )[1],
            defaultDonationAmount: state.widget.activeAction.defaultDonationAmount,
            description,
            isCustomDonation: state.donation.isCustomDonation,
            isLegacyDonation,
            isMobileResolution: state.widget.isMobileResolution,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isMultiDonation:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multiDonation,
            partnerName: state.widget.activeAction.partner?.name,
            paymentMethod: state.widget.activeAction.partner?.paymentMethod,
            regularRowSize: state.widget.regularRowSize,
            selectedAmount: state.donation.selectedAmount,
            shortActionName:
                state.widget.activeAction.shortName || state.widget.activeAction.name,
            supportedNativePaymentTypes: state.donation.supportedNativePaymentTypes
        };
    },
    {
        cacheFormData,
        donateMore,
        onBackWithinCard,
        onCustomAmountChanged,
        selectAmount,
        setExitingCardProps,
        setOverlayPartnerVisible
    }
)(DonationStart);
